var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgSendMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8967 21.1297L20.4767 24.7197L16.8867 28.3097L18.3067 29.7197L23.3067 24.7197L18.3067 19.7197L16.8967 21.1297ZM23.8967 21.1297L27.4767 24.7197L23.8867 28.3097L25.3067 29.7197L30.3067 24.7197L25.3067 19.7197L23.8967 21.1297Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3066 23.7197H4.30664V8.62973L15.7366 16.5397C15.904 16.6559 16.1029 16.7181 16.3066 16.7181C16.5104 16.7181 16.7092 16.6559 16.8766 16.5397L28.3066 8.62973V17.7197H30.3066V7.71973C30.3066 7.18929 30.0959 6.68059 29.7209 6.30551C29.3458 5.93044 28.8371 5.71973 28.3066 5.71973H4.30664C3.77621 5.71973 3.2675 5.93044 2.89243 6.30551C2.51735 6.68059 2.30664 7.18929 2.30664 7.71973V23.7197C2.30664 24.2502 2.51735 24.7589 2.89243 25.1339C3.2675 25.509 3.77621 25.7197 4.30664 25.7197H14.3066V23.7197ZM26.1066 7.71973L16.3066 14.4997L6.50664 7.71973H26.1066Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMail);
export default __webpack_public_path__ + "static/media/send-mail.80ba428869771855148536476190cadf.svg";
export { ForwardRef as ReactComponent };